import { Chip, ChipProps } from "@mui/material";

type Props = {
  nbMore: number;
} & ChipProps;

function LimitTag({ nbMore, ...chipProps }: Props) {
  return <Chip color="primary" label={`+${nbMore}`} {...chipProps} />;
}

export default LimitTag;
